import { Component, Input } from '@angular/core';
import * as Models from '../../../models/models-index';
import * as SharedServices from '../../../services/services-index';
import { Subscription } from 'rxjs/internal/Subscription';
import { FunnelRow, Segment } from './types';
import { BehaviorSubject, map, startWith } from 'rxjs';

@Component({
    selector: 'horizontal-funnel',
    templateUrl: './horizontal-funnel.component.html',
    styleUrls: ['./horizontal-funnel.component.scss'],
    standalone: false
})
export class HorizontalFunnelV2Component implements Models.ElementComponent {
  @Input() set dataSets(value: Models.DataSet[]) {
    if (!!value) {
      this.processData(value[0]);
      this.dataSetSubject.next(value[0]);
    } else {
      this.dataSetSubject.next(undefined);
    }
  }

  dataSetSubject: BehaviorSubject<Models.DataSet> = new BehaviorSubject(undefined);
  isDataSetLoaded$ = this.dataSetSubject.pipe(
    map((dataSet) => !!dataSet),
    startWith(false));

  @Input() settings: Models.ElementSettings;
  funnelRows: FunnelRow[] = [];
  filterBreadcrumbsForExport: string[] = [];
  subscriptions: Subscription[] = [];

  headerPlaceholders = Array(4).fill(0); // 4 placeholders for headers
  rowPlaceholders = Array(3).fill(0); // 3 placeholder rows
  segmentPlaceholders = Array(4).fill(0); // 4 segments per row

  constructor(
    private filterService: SharedServices.FilterService,
    private dataTableService: SharedServices.DataTableService
  ) {}

  ngOnInit(): void {
  }

  private processData(dataSet: Models.DataSet): void {
    this.subscriptions.push(
      this.dataTableService.pathToPurchasePrintButtonClicked$.subscribe(data => {
        this.filterService.requestBreadcrumbString();
      }),
      this.filterService.filterBreadcrumbsReturned$.subscribe(breadcrumbs => {
        this.filterBreadcrumbsForExport = breadcrumbs;
      })
    );

    //validate metrics configured exist in dataset
    const missingMetrics = this.settings.metrics.filter(metric => !dataSet.columns.find(col => col.name === metric.name));
    console.log('missing metrics', missingMetrics);

    this.mapRowsToFunnelRows(dataSet);
  }

  get headers() {
    return this.settings.metrics
      .map(metric => this.dataSetSubject.value.columns.find(col => col.name === metric.name).displayName);
  }

  getSegmentsForDisplay(row: FunnelRow): {
    segment: Segment,
    value: string,
    classes: string[],
    path?: string,
    pathClass: string
  }[] {
    return row.segments.map((s, idx) => ({
      segment: s,
      value: s.value,
      classes: [
        'box',
        'box-' + (s.color || 'gray'),
        'box' + (idx + 1)
      ],
      path: idx != row.segments.length - 1 ? this.calculatePath(s, idx) : undefined,
      pathClass: `box-${s.color || 'gray'}`
    }));
  }

  calculatePath = (segment: Segment, idx: number): string => `M0,${idx * 5} L25,${5 + (idx * 5)} L25,${95 - (idx * 5)} L0,${100 - (idx * 5)}z`;

  private mapRowsToFunnelRows(dataSet: Models.DataSet) {
    //console.log('dataset', this.dataSet);
    if(dataSet.rows?.length === 0) return;

    // build indexes for each segment
    const indexes = this.settings.metrics.map(metric => {
      const index = dataSet.columns.findIndex(col => col.name === metric.name);
      const popIndex = dataSet.columns.findIndex(col => col.name === metric.pop);
      return { index, popIndex };
    });

    this.funnelRows = dataSet.rows.map(row => {
      // first element is always segment name
      const segmentName = (row[0].label || row[0].value)?.toString();
      const segments : Segment[] = indexes.map(i => {
        const value = row[i.index];
        const label = (value?.label || value?.value)?.toString()
        const pop = row[i.popIndex]?.value ?? 0;
        //console.log('pop', pop);
        return new Segment(
          label,
          label,
          null,
          null,
          value?.value > pop ? 'green' : 'red'
        );
      });

      return new FunnelRow(segmentName, segments);
    });
  }
}
